import { render, staticRenderFns } from "./QuarterSummaryCardContent.vue?vue&type=template&id=74bc03c2&scoped=true&"
import script from "./QuarterSummaryCardContent.vue?vue&type=script&lang=ts&"
export * from "./QuarterSummaryCardContent.vue?vue&type=script&lang=ts&"
import style0 from "./QuarterSummaryCardContent.vue?vue&type=style&index=0&id=74bc03c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bc03c2",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VCol,VContainer,VRow})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74bc03c2')) {
      api.createRecord('74bc03c2', component.options)
    } else {
      api.reload('74bc03c2', component.options)
    }
    module.hot.accept("./QuarterSummaryCardContent.vue?vue&type=template&id=74bc03c2&scoped=true&", function () {
      api.rerender('74bc03c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/reports/dashboard/components/QuarterSummaryCardContent.vue"
export default component.exports